import type { ApplicationAccount as ApplicationAccountModel } from '@/adapters/catalogv1.g';

export function extractApplicationAccount(model: ApplicationAccountModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    applicationRef: model.application_ref ?? '',
    accountRef: model.account_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogApplicationAccount = ReturnType<
  typeof extractApplicationAccount
>;
